import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button } from '@mui/material';
import { styled } from '@mui/system';

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[100],
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(5, 3),
  height: '100%',
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(5),
    padding: theme.spacing(0, 2)
  }
}));

const StyledCardMedia = styled(CardMedia)({
  width: '227px',
  height: '192px',
  objectFit: 'contain'
});

const StyledCardContent = styled(CardContent)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexGrow: 1
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: '19px',
  fontWeight: 700,
  lineHeight: 1,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(1)
}));

const StyledDescription = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '18px',
  textAlign: 'center',
  marginBottom: theme.spacing(2)
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '24px',
  marginTop: 'auto'
}));

const ItemSelectionCard = ({ title, description, buttonText, imageSrc }) => {
  return (
    <StyledCard elevation={0}>
      <StyledCardMedia component="img" image={imageSrc} alt="" loading="lazy" />
      <StyledCardContent>
        <StyledTitle variant="h6" component="h3">
          {title}
        </StyledTitle>
        <StyledDescription variant="body2">{description}</StyledDescription>
        <StyledButton variant="contained" color="primary">
          {buttonText}
        </StyledButton>
      </StyledCardContent>
    </StyledCard>
  );
};

export default ItemSelectionCard;
